import { lazy } from 'react'

export const DynamicPages = {
	Home: lazy(() => import('../pages/home').then((m) => ({ default: m.Home }))),
	ComoSeFaz: lazy(() => import('../pages/como-se-faz/como-se-faz').then((m) => ({ default: m.ComoSeFaz }))),
	Auth: lazy(() => import('../pages/auth/auth').then((m) => ({ default: m.Auth }))),
	Dashboard: lazy(() => import('../pages/dashboard').then((m) => ({ default: m.Dashboard }))),
	Reports: lazy(() => import('../pages/reports/reports').then((m) => ({ default: m.Reports }))),
	CreateReport: lazy(() => import('../pages/reports/reports-new/reports-new').then((m) => ({ default: m.CreateReport }))),
	EditReport: lazy(() => import('../pages/reports/reports-edit/reports-edit').then((m) => ({ default: m.EditReport }))),
	Projects: lazy(() => import('../pages/projects/projects').then((m) => ({ default: m.Projects }))),
	CreateProject: lazy(() => import('../pages/projects/projects-new/projects-new').then((m) => ({ default: m.CreateProject }))),
	EditProject: lazy(() => import('../pages/projects/projects-edit/projects-edit').then((m) => ({ default: m.EditProject }))),
	Wallet: lazy(() => import('../pages/wallet').then((m) => ({ default: m.default }))),
	Account: lazy(() => import('../pages/account').then((m) => ({ default: m.Account }))),
};